module.exports = __webpack_public_path__ + "components/rewards/dogtag/static/icon-2f4f3e26471c9a4230afaee158da2073.svg";